import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';

import { BaseProvider } from './base-provider';
import { GlobalsService } from './globals.service';
import { LsHelperService } from './ls-helper.service';
import { Subject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class PaymentPlanService extends BaseProvider {

  paymentInfo: any;
  paymentPlanIds: string;
  installmentReceiptInfo: any;
  processId: number;

  constructor(
    private globals: GlobalsService,
    private http: HttpClient,
    private ls: LsHelperService
  ) { 
    super();

    this.baseUrl = 'invoicePaymentPlan';
  }

  pay(transactionId: any, data: any){
    return new Promise( (resolve, reject) => {
      this.url = this.globals.dataUrl + this.baseUrl + `/init/${transactionId}`;

      this.http.post(
        this.url,
        data
      )
      .subscribe( 
        (data: any) => { resolve( data ); },
        (err: any) => { reject(err); }
      );
    });
  }

  paySeveral(transactionId: any, data: any){
    return new Promise( (resolve, reject) => {
      this.url = this.globals.dataUrl + this.baseUrl + `/pay/${transactionId}`;

      this.http.post(
        this.url,
        data
      )
      .subscribe( 
        (data: any) => { resolve( data ); },
        (err: any) => { reject(err); }
      );
    });
  }

  getInstallmentById(installmentId){
    return new Promise( (resolve, reject) => {
      this.url = this.globals.dataUrl + this.baseUrl + `/installment/${installmentId}`; 

      this.http.get(
        this.url
      )
      .subscribe(
        (data: any) => { resolve(data); },
        (err: any) => { reject(err); }
      );
    });
  }

  getPaymentInfo(transactionId: any){
    return new Promise( (resolve, reject) => {
      this.url = this.globals.dataUrl + this.baseUrl + `/info/${transactionId}`; 

      this.http.get(
        this.url
      )
      .subscribe(
        (data: any) => { resolve(data); },
        (err: any) => { reject(err); }
      );
    });
  }

  getPaymentList(transactionId: any){
    return new Promise( (resolve, reject) => {
      this.url = this.globals.dataUrl + this.baseUrl + `/installment/process/${transactionId}`;

      this.http.get(
        this.url
      )
      .subscribe(
        (data: any) => { resolve(data); },
        (err: any) => { reject(err); }
      );
    });
  }

  getTransactions(){
    return new Promise( (resolve, reject) => {
      this.url = this.globals.dataUrl + this.baseUrl + `/process`;

      this.http.get(
        this.url
      )
      .subscribe(
        (data: any) => { resolve(data); },
        (err: any) => { reject(err); }
      );
    });
  }

  paymentPlanValidation(ProcessId){
    return new Promise( (resolve, reject) =>{
      this.url = this.globals.dataUrl + this.baseUrl + `/validation/${ProcessId}`;

      this.http.get(
        this.url
      )
      .subscribe(
        (data: any) => { resolve(data); },
        (err: any) => { reject(err); }
      );

    });
  }


}
